let mirrorPeerReady = false

export function setMirrorPeerReady(ready: boolean): void {
  mirrorPeerReady = ready
}

export function resetMirrorPeerReady(): void {
  mirrorPeerReady = false
}

/** POS-only: whether Cashier Mirror answered the liveness handshake for the current session. */
export function isMirrorReady(): boolean {
  return mirrorPeerReady
}
